import type { OpeningHoursType } from '../../admin/experiences/openingHours/openingHours';
import type { DayOfWeek } from '../../common/enum/dayOfWeek';
import type { PictureView } from '../../common/pictureView/pictureView';

export const enum ExtranetPackStatus {
  PUBLISHED = 'PUBLISHED',
  SETUP = 'SETUP',
  UNPUBLISHED = 'UNPUBLISHED',
  HIDDEN = 'HIDDEN',
  DELETED = 'DELETED',
}

export type ExtranetHotelPackExperience = {
  id: number;
  packId: number;
  priority: number;
  createdAt: string;
  updatedAt: string;
  experienceId: number;
  isPerNight: boolean;
  discount?: number;
  isOptional: boolean;
  quantity: number;
  isPerPerson: boolean;
  isIncluded: boolean;
};

export type ExtranetHotelPackRoom = {
  id: number;
  packId: number;
  roomId: number;
  priority: number;
  createdAt: string;
  updatedAt: string;
};

/**
 * Extranet Hotel Package Types
 */
export type ExtranetHotelOldPack = {
  id: number;
  hotelId: number;
  aliasForHotel: string;
  aliasForUser?: string;
  published: boolean;
  dayPackage: boolean;
  slug: string;
  singleCustomerDiscount?: string;
  additionalAdultPrice?: string;
  additionalChildPrice?: string;
  defaultMaxBooking?: number;
  autoDiscountRate?: string;
  lastMinuteAutoDiscountRate?: string;
  lastMinuteAutoDiscountDays?: number;
  childrenAllowed: boolean;
  coverLabel?: string;
  horizontalCoverPicture?: PictureView;
};

type ExtranetHotelPackRooms = {
  id: number;
  packId: number;
  roomId: number;
  priority: number;
  createdAt: string;
  updatedAt: string;
};

export type ExtranetHotelPackExperiences = {
  id: number;
  packId: number;
  priority: number;
  createdAt: string;
  updatedAt: string;
  experienceId: number;
  isPerNight: boolean;
  discount?: number;
  isOptional: boolean;
  quantity: number;
  isPerPerson: boolean;
  isIncluded: boolean;
};

export type MaxBookingConfiguration =
  | {
      type: 'CONSTANT';
      configuration?:
        | {
            maxBooking: number;
          }
        | undefined;
    }
  | {
      type: 'DAILY';
      days: {
        [key in DayOfWeek]: {
          maxBooking: number;
        };
      };
    }
  | undefined;
export type ExtranetHotelPack = {
  id: number;
  hotelId: number;
  nameForHotel: string;
  nameForUser: string;
  slug: string;
  status: ExtranetPackStatus;
  isDaytime: boolean;
  minChargedPax?: number;
  maxAllowedPax?: number;
  maxAllowedAdult?: number;
  maxAllowedChild?: number;
  openingHours?: OpeningHoursType;
  horizontalCoverPicture?: PictureView;
  oldPackId?: number;
  maxBookingConfiguration?: MaxBookingConfiguration;
  packRooms: ExtranetHotelPackRooms[];
  packExperiences: ExtranetHotelPackExperiences[];
};

export type ExtranetHotelPacks = {
  packs: ExtranetHotelPack[];
  oldPacks: ExtranetHotelOldPack[];
};
